import { message } from 'antd'
import { deleteUser } from '../../../HttpRequests/users'
import { getProps } from '../props'
import handleException from '../../../Core/Helpers/handleException'

export default () => async () => {

  const { id, onClose, didDelete } = getProps()

  try {

    await deleteUser({ id })

    message.success('User Deleted')

    onClose()

    if (didDelete) didDelete()

  } catch (error) {

    handleException(error)

  }

}
